import styled from 'styled-components';
import { InputContainer, Label } from '../../styled.js';
import { unit, padding } from '../../../v2/foundation/spacing/utils.js';
import { themeGet } from '../../../v2/foundation/theme/themeGet/get.js';
import { interactiveTransition } from '../../../v2/foundation/theme/utils.js';

var HEIGHT = 6.5;
var SPACING = 0.5;
var Input = styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-sh5ezi-0"
})(["position:absolute;margin:0;width:100%;height:100%;border:0;-webkit-appearance:none;opacity:0;:focus-visible{outline:none;}"]);
var StyledInputContainer = styled(InputContainer).withConfig({
  displayName: "StyledInputContainer",
  componentId: "sc-sh5ezi-1"
})(["width:", ";height:", ";"], unit(10.5), unit(HEIGHT));
var Handle = styled.div.withConfig({
  displayName: "Handle",
  componentId: "sc-sh5ezi-2"
})(["width:", ";height:", ";background-color:", ";border-radius:", ";box-shadow:0 ", " ", " rgba(0,0,0,0.15);transition:transform 300ms;"], unit(5.5), unit(5.5), themeGet('colors.gray.0'), themeGet('borderRadius.circle'), unit(0.5), unit(1));
var Overlay = styled.div.withConfig({
  displayName: "Overlay",
  componentId: "sc-sh5ezi-3"
})(["position:absolute;top:0;right:0;bottom:0;left:0;", ";background-color:", ";border-radius:", ";pointer-events:none;", ";", ":hover &{background-color:", ";}", ":hover:checked &{background-color:", ";}", ":focus-visible + &{box-shadow:0 0 0 ", " ", ";}", ":focus-visible:checked + &{box-shadow:0 0 0 ", " ", ";}", ":checked + &{background-color:", ";}", ":checked + & > ", "{transform:translateX(", ");}", ":disabled + &{opacity:0.5;}", ":checked:disabled + &{opacity:0.5;}", ":disabled + & > ", "{box-shadow:none;}"], padding(SPACING), themeGet('colors.primary.500'), unit(HEIGHT), interactiveTransition, Input, themeGet('colors.primary.600'), Input, themeGet('colors.secondary.700'), Input, unit(1), themeGet('colors.focus.primary'), Input, unit(1), themeGet('colors.focus.secondary'), Input, themeGet('colors.secondary.500'), Input, Handle, "calc(100% - " + unit(SPACING * 2 + 0.5) + ")", Input, Input, Input, Handle);
var StyledLabel = styled(Label).withConfig({
  displayName: "StyledLabel",
  componentId: "sc-sh5ezi-4"
})(["margin-left:0;margin-right:", ";"], unit(1));

export { Handle, Input, Overlay, StyledInputContainer, StyledLabel };
